import { Box, Button, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import Instagram from '@mui/icons-material/Instagram';
import Propic from "../../../images/Profile.png";
import Profiletabstart from './Profiletabstart';
import { Link, useParams } from 'react-router-dom';
import { API_URL, APP_URL } from '../../../Config';
import axios from 'axios';
import { useWeb3React } from '@web3-react/core';
import swal from 'sweetalert';


const Profile = () => {
  const { account } = useWeb3React();
  const [user, setuserdata] = useState([]);
  const [followShow, setFollowShow] = useState(true);
  const [followingShow, setFollowingShow] = useState(false);
  const [following, setFollowing] = useState(0);
  const [followers, setFollowers] = useState(0);

  const params = useParams();
  const address = "0x00"
  // GET THE OWNER DETAILS

  const checkFollowing = async () => {

    if (account != undefined) {

      var formdata = new FormData();
      formdata.append("followadd", params.account);
      formdata.append("address", account);
      formdata.append("type", "userFollowers");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${API_URL}/user_follow.php`, requestOptions)
        .then(response => response.json())
        .then(result => {
          setFollowers(result);
        })
        .catch(error => console.log('error', error));
    }
  }

  const getuserDetails = async () => {

    await axios
      .post(`${API_URL}/my-items.php?type=users&address=${params.account}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setuserdata(res.data[0]);
      })
      .catch(console.log);

    var formdata = new FormData();
    formdata.append("followadd", params.account);
    formdata.append("address", account);
    formdata.append("type", "following");

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${API_URL}/user_follow.php`, requestOptions)
      .then(response => response.json())
      .then(result => {

        if (result > 0) {
          setFollowShow(false);
          setFollowingShow(true);
        }
      })
      .catch(error => console.log('error', error));



  };


  const checkUserFollow = async () => {


    var formdata = new FormData();
    formdata.append("followadd", params.account);
    formdata.append("address", account);
    formdata.append("type", "userFollowing");

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${API_URL}/user_follow.php`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result > 0) {
          setFollowing(result);
        }
      })
      .catch(error => console.log('error', error));

  }


  const Follow = async () => {
    if (account == undefined) {
      swal('warning', 'Please connect your waller', 'warning');
      return;
    }
    if (account == params.account) {
      swal('warning', 'you can\'t follow yourself', 'warning');
      return;
    }
    var formdata = new FormData();
    formdata.append("followadd", params.account);
    formdata.append("address", account);
    formdata.append("type", "follow");

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${API_URL}/user_follow.php`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result) {
          checkFollowing();
          setFollowShow(false);
          setFollowingShow(true);
        }
      })
      .catch(error => console.log('error', error));

  }

  const Unfollow = async () => {
    if (account == undefined) {
      swal('warning', 'Please connect your waller', 'warning');
      return;
    }

    var formdata = new FormData();
    formdata.append("followadd", params.account);
    formdata.append("address", account);
    formdata.append("type", "unfollow");

    var requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch(`${API_URL}/user_follow.php`, requestOptions)
      .then(response => response.json())
      .then(result => {

        if (result == true) {
          checkFollowing();
          setFollowShow(true);
          setFollowingShow(false);
        }
      })
      .catch(error => console.log('error', error));
  }



  useEffect(() => {
    getuserDetails();
    checkFollowing();
    checkUserFollow();
  }, [address, account]);

  return (
    <div>

      <Box className='bgcover'>
        {user ? <img src={APP_URL + '/' + user.coverphoto} width='100%' /> :
          <img src={Propic} width='100%' />}

      </Box>
      <Box className='holder'>
        <Container maxWidth='xl'>
          <Grid container spacing={2}>
            <Grid item lg={12} sm={12} md={12} xs={12}>
              <Box className='bot_parts'>
                {/* <img src='./img/card-item.jpg' width='' /> */}
                <img src={user ? APP_URL + '/' + user.Userimage : Propic} width='100%' />

                <Typography variant='h4' fontSize='25px' fontWeight='600'> {user ? user.Username : 'Testname'}</Typography>
                {user.length > 0 ?
                  <Typography variant='h6'>{user ? user.Useraddress : "0x000000000000000000000000000000000000"} </Typography> :
                  <Typography variant='h6'>{params.account ? params.account : "0x000000000000000000000000000000000000"}</Typography>
                }
              </Box>
              <br></br>
              <Box className='bio' paddingY={2}>
                <Typography variant='h6' fontSize='17px' justifyContent='center' fontWeight='normal'>
                  {user && user.Userbio}
                </Typography>
              </Box>
              <Box display='flex' alignItems='center' justifyContent='center' fontWeight='normal'  >
                <Box className='main_work'>
                  <b> {followers}</b>  Followers
                </Box>
                <Box className='main_work'>
                  <Typography variant='' component='div' fontWeight='' >
                    <b> {following} </b> Following
                  </Typography>
                </Box>
              </Box>
              <Box display='flex' alignItems='center' justifyContent='center' fontWeight='Bold' paddingY={3} >
                <Box className='main_work'>
                  {followShow && <Button className='follow_page' variant='contained' onClick={Follow}> Follow </Button>}
                  {followingShow && <Button className='follow_page' variant='contained' onClick={Unfollow}> Following </Button>}
                </Box>

                <Box className='main_work'>
                  <Typography variant='' component='div' fontWeight='Bold' >
                    <a href={`https://twitter.com/${user.Usertwitname && user.Usertwitname}`} target='blank' color='#fff'> <TwitterIcon className='ambel' /> </a>
                    <a href={`https://www.facebook.com/${user.Userfacebookname && user.Userfacebookname}`} target='blank' color='#fff'> <FacebookIcon className='ambel' />  </a>
                    <a href={`https://www.instagram.com/${user.Userinstaname && user.Userinstaname}`} target='blank' color='#fff'>  <Instagram className='ambel' /> </a>
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Profiletabstart />
    </div>
  )
}

export default Profile;